"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.widgets.disabled': '小部件功能在您当前的计划中不可用。',
};
